import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/** Every navigation starts at its destination, including repeated menu clicks. */
export function ScrollNavigation() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';
    return () => { window.history.scrollRestoration = previous; };
  }, []);

  useEffect(() => {
    let firstFrame = 0;
    let secondFrame = 0;
    firstFrame = window.requestAnimationFrame(() => {
      secondFrame = window.requestAnimationFrame(() => {
        let target: HTMLElement | null = null;
        try { target = location.hash ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null; } catch { /* An invalid hash still opens the top of the page. */ }
        const header = document.querySelector<HTMLElement>('.moova-header');
        const margin = target ? parseFloat(getComputedStyle(target).scrollMarginTop) || (header?.offsetHeight ?? 0) + 20 : 0;
        const top = target ? Math.max(0, target.getBoundingClientRect().top + window.scrollY - margin) : 0;
        window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
    });
    return () => { window.cancelAnimationFrame(firstFrame); window.cancelAnimationFrame(secondFrame); };
  }, [location.key, location.pathname, location.search, location.hash]);

  useEffect(() => {
    const onAnchor = (event: MouseEvent) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
      const link = event.target instanceof Element ? event.target.closest<HTMLAnchorElement>('a[href]') : null;
      if (!link || link.target || link.hasAttribute('download')) return;
      const destination = new URL(link.href, window.location.href);
      if (!destination.hash || destination.origin !== window.location.origin || destination.pathname !== location.pathname || destination.search !== location.search) return;
      event.preventDefault();
      navigate(destination.pathname + destination.search + destination.hash);
    };
    document.addEventListener('click', onAnchor);
    return () => document.removeEventListener('click', onAnchor);
  }, [location.pathname, location.search, navigate]);

  return null;
}
